import React, { useState } from 'react'
import styles from './TrophyDetailCard.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons'
import { useTranslation } from 'next-i18next'
import { TrophyAttributeDto } from '~/modules/Trophies/Infrastructure/TrophyDetailComponentDto'

interface Props {
  attributesDto: TrophyAttributeDto[]
}

export const TrophyDetailCardAttributesList: React.FC<Props> = ({ attributesDto }) => {
  const { t } = useTranslation('trophy_details')
  const [openAttributes, setOpenAttributes] = useState(false)
  const attributesItems = attributesDto.map(attribute => (
    <div
      className={ styles.trophyDetailCard__trophyAttributeItem }
      key={ attribute.type }
    >
      { attribute.type }

      <div className={ styles.trophyDetailCard__trophyAttributeItemValue }>
        { attribute.value }
      </div>
    </div>
  ))

  return (<>
    <h2
      data-qa='trophy-attributes-title'
      className={ styles.trophyDetailCard__attributesTitle }
      onClick={ () => setOpenAttributes(!openAttributes) }
    >
      { t('attributes_title') }
      <FontAwesomeIcon
        icon={ faAngleDown }
        rotation={ openAttributes ? 180 : undefined }
      />
    </h2>
    <div
      data-qa='trophy-attributes'
      className={ `
        ${styles.trophyDetailCard__trophyAttributesList}
        ${openAttributes && styles.trophyDetailCard__trophyAttributesList_open}
      ` }
    >
      { attributesItems }
    </div>
  </>)
}
